import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext, useState } from "react";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../service/AuthService";
import AppContext from "../../context/AppContext";
import CommonButton from "../../components/common/CommonButton";

const ResetPasswordPage = ({ emaill }) => {
  const location = useLocation();
  emaill = location.state?.emaill || emaill;
  const fromProfile = location.state?.fromProfile || false;
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { theme } = useContext(AppContext);
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const data = await resetPassword(emaill, values.newPassword);
      if (data.header && data.header.code === 600) {
        if (fromProfile) {
          navigate("/"); 
        } else {
          window.location.reload();
        }
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="bg-gray-50 flex justify-center items-center min-h-[100dvh] overflow-y-auto px-4 py-6 sm:p-8">
        <div className="px-4 py-8 sm:px-8 md:px-12 lg:px-20 w-full lg:w-1/2 max-w-lg mx-auto">
          <h1 className="text-3xl sm:text-4xl text-blue-800 font-bold mb-10 sm:mb-20">BluField</h1>
          <h3 className="text-base sm:text-md text-gray-500 font-semibold">
            Reset Your Password
          </h3>
          <div className="mt-5">
            <Formik
              initialValues={{
                newPassword: "",
              }}
              validationSchema={Yup.object({
                newPassword: Yup.string()
                  .min(8, "Password must be at least 8 characters")
                  .required("Required"),
                confirmPassword: Yup.string()
                  .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
                  .required("Required"),
              })}
              onSubmit={handleSubmit}>
              <Form>
                <div className="mb-5">
                  <label
                    htmlFor="newPassword"
                    className="block text-sm font-semibold leading-6 text-gray-400 mb-2"
                  >
                    New Password
                  </label>
                  <div className="relative">
                    <Field
                      name="newPassword" 
                      id="newPassword" 
                      type={showNewPassword ? "text" : "password"}
                      className={`w-full border border-gray-300 rounded-md py-2.5 px-3 shadow-sm 
                        focus:outline-none focus:border-blue-500  ${
                              theme === "dark"
                                ? "text-black"
                                : theme === "high-contrast"
                                ? "text-black"
                                : ""
                            }`}
                    />
                    <button
                      type="button"
                      onClick={toggleNewPasswordVisibility}
                      className="absolute text-sm text-gray-400 top-3.5 right-3.5 w-8 h-8 flex items-center justify-center"
                      aria-label={showNewPassword ? "Hide password" : "Show password"}
                    >
                      {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  <ErrorMessage
                    name="newPassword"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div className="mb-5">
                  <label
                    htmlFor="confirmPassword"
                    className="block text-sm font-semibold leading-6 text-gray-400 mb-2"
                  >
                    Confirm Password
                  </label>
                  <div className="relative">
                    <Field
                      name="confirmPassword" 
                      id="confirmPassword" 
                      type={showConfirmPassword ? "text" : "password"}
                      className={`  ${
                              theme === "dark"
                                ? "text-black"
                                : theme === "high-contrast"
                                ? "text-black"
                                : ""
                            } w-full border border-gray-300 rounded-md py-2.5 px-3 shadow-sm
                       focus:outline-none focus:border-blue-500`}
                    />
                    <button
                      type="button"
                      onClick={toggleConfirmPasswordVisibility}
                      className="absolute text-sm text-gray-400 top-3.5 right-3.5 w-8 h-8 flex items-center justify-center"
                      aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                    >
                      {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div className="w-full [&>div]:!block [&>div]:!w-full pt-2">
                  <CommonButton colorIntent="primary"
                    type="submit"
                    variant="primary"
                    className="w-full !justify-center rounded-md min-h-[42px]"
                  >
                    Continue
                  </CommonButton>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
        <div className="w-1/2 h-screen hidden lg:block max-h-[850px]">
          <img
            src='https://res.cloudinary.com/dpdvpazfv/image/upload/v1753344908/loginImage_qiuxl2.png'
            alt="Placeholder"
            className="object-cover w-full h-full rounded-2xl"
          />
        </div>
      </div>
    </>
  );
};

export default ResetPasswordPage;
